import { useEffect, useState } from "react";

import styled from "@emotion/styled";

import { Box, Flex } from "@/components/layout/flexbox";
import { PageTitle } from "@/components/pieces/onboarding/PageTitle";

const LOADING_STEPS = [
  "",
  "Evaluating Expertise",
  "",
  "Identifying Focus",
  "",
  "Checking Availability",
  "",
  "Calculating Fit",
  "",
  "Estimating Costs",
  "",
  "Checking References",
  "",
  "Evaluating Work History",
  "",
  "Assessing Communication Style",
];

const LOADING_ICON = [
  "",
  "⚖️",
  "",
  "🔍",
  "",
  "🗓",
  "",
  "🧩",
  "",
  "💵",
  "",
  "📣",
  "",
  "💼",
  "",
  "💬",
];

export function LoadingCoaches() {
  const [loadingStep, setLoadingStep] = useState(1);
  const [numPeriods, setNumPeriods] = useState(1);

  useEffect(() => {
    let timer1 = setTimeout(
      () => {
        setLoadingStep(
          loadingStep === LOADING_STEPS.length ? 1 : loadingStep + 1,
        );
        setNumPeriods(1);
      },
      loadingStep % 2 == 1 ? 500 : 5000,
    );
    return () => {
      clearTimeout(timer1);
    };
  }, [loadingStep]);

  useEffect(() => {
    let timer2 = setTimeout(() => {
      setNumPeriods(numPeriods < 3 ? numPeriods + 1 : 1);
    }, 500);

    return () => {
      clearTimeout(timer2);
    };
  }, [numPeriods]);

  return (
    <>
      <Flex justifyContent="center" alignItems="center">
        <Box width={[0.9, 500, 500]} pt={5}>
          <PageTitle
            style={{
              textAlign: "center",
              position: "relative",
            }}
            title="Finding Great Matches"
            subtitle={
              <RotatingContainer css={{ position: "relative" }}>
                <Flex
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    transition: "all 1000ms ease",
                    opacity: loadingStep % 2 == 1 ? 0 : 1,
                    transform:
                      loadingStep % 2 == 1
                        ? "translateY(-100%)"
                        : "translateY(0%)",
                  }}
                  justifyContent="center"
                >
                  <Box>{LOADING_STEPS[loadingStep - 1]}</Box>
                  <Box ml={2} className="rotating">
                    {LOADING_ICON[loadingStep - 1]}
                  </Box>
                </Flex>
              </RotatingContainer>
            }
          />
        </Box>
      </Flex>
    </>
  );
}

const RotatingContainer = styled(Box)`
  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  .rotating {
    -webkit-animation: rotating 4s linear infinite;
    -moz-animation: rotating 4s linear infinite;
    -ms-animation: rotating 4s linear infinite;
    -o-animation: rotating 4s linear infinite;
    animation: rotating 4s linear infinite;
  }
`;
